import React, { useState, useEffect, useMemo } from 'react';
import { http } from '../../utils/http';
import Swal from 'sweetalert2';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Buttons/Button';
import CreateExcel from '../../class/CreateExcel';
import TowerList from './components/TowerList';
import Tab from './components/Tab';
import ReservationCard from './components/ReservationCard';
import ServiceCard from './components/ServiceCard';
import ItemPrint from './components/ItemPrint';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

const typeView = {
   RESERVACIONES: 'RESERVACIONES',
   SERVICIOS: 'SERVICIOS',
};

export default function MomentReservaction() {
   const [reservaciones, setReservaciones] = useState([]);
   const [stop, setStop] = useState(false);
   const [tower, setTower] = useState([]);
   const [form, setForm] = useState({});
   const [towerSeleted, setTowerSelected] = useState(
      '5f63ac447fd08913d3eef97b',
   );
   const [menus, setMenus] = useState([]);
   const [itemsSelected, setItemsSelected] = useState([]);
   const [showModal, setShowModal] = useState(false);
   const [showModalPenalizacion, setShowModalPenalizacion] = useState(false);
   const [view, setView] = useState(typeView.RESERVACIONES);
   const [showReporte, setShowReporte] = useState(false);
   const [filtered, setFiltered] = useState([]);
   const [fechaInicio, setFechaInicio] = useState('');
   const [fechaFin, setFechaFin] = useState('');

   const listReservations = useMemo(() => {
      if (!reservaciones) return [];
      return [...reservaciones]
         .sort(
            (a, b) => parseISO(b.schedule.start) - parseISO(a.schedule.start),
         )
         .sort((a, b) => {
            if (a.metric.progress > 100 && b.metric.progress <= 100) return 1;
            if (b.metric.progress > 100 && a.metric.progress <= 100) return -1;
            return 0;
         });
   }, [reservaciones]);

   useEffect(() => {
      const pollData = () => {
         if (!stop) {
            _getReservaciones();
            getFoods();
         }
      };
      const interval = setInterval(pollData, 30000);
      return () => clearInterval(interval);
   }, [stop, towerSeleted]);

   useEffect(() => {
      _getTowers();
   }, []);

   useEffect(() => {
      _getReservaciones();
      getFoods();
   }, [towerSeleted]);

   const _getReservaciones = async () => {
      if (!towerSeleted) return;
      try {
         const res = await http(
            `/reservation/moment?tower=${towerSeleted}`,
            'GET',
         );
         if (res?.data?.data?.list) {
            setReservaciones(res.data.data.list);
         }
      } catch (err) {
         console.error(err);
      }
   };

   const getFoods = async () => {
      try {
         const res = await http(
            `/request-food/today-and-tomorrow?tower=${towerSeleted}`,
            'GET',
         );
         if (res?.data?.data) {
            setMenus(res.data.data);
         }
      } catch (err) {
         console.error(err);
      }
   };

   const _getTowers = async () => {
      try {
         const res = await http('/tower', 'GET');
         setTower(res.data.data);
      } catch (err) {
         console.error(err);
      }
   };

   const handlerSend = async () => {
      if (!form.penalty) {
         Swal.fire({
            title: 'Error!',
            text: 'Ingresa la cantidad a penalizar',
            icon: 'error',
            confirmButtonText: 'ok',
         });
         return;
      }
      try {
         await http('/reservation/penalty', 'POST', form);
         Swal.fire({
            title: 'Se ha registrado la penalización',
            icon: 'success',
         });
      } catch (err) {
         console.error(err);
      } finally {
         _getReservaciones();
         setStop(false);
         setShowModalPenalizacion(false);
      }
   };

   const handleDescargar = (data) => {
      const excel = new CreateExcel(
         'Reservaciones',
         [
            { headerName: 'TORRE', field: 'tower' },
            { headerName: 'PISO', field: 'piso' },
            { headerName: 'AMENIDAD', field: 'amenidad' },
            { headerName: 'USUARIO', field: 'usuario' },
            { headerName: 'CORREO', field: 'email' },
            { headerName: 'CLAVE', field: 'code' },
            { headerName: 'INICIO', field: 'start' },
            { headerName: 'FIN', field: 'end' },
            { headerName: 'PENALIZADO', field: 'penalizado' },
         ],
         filtered.map((item) => ({
            tower: item?.tower?.name,
            piso: item?.floor?.name,
            amenidad: item?.amenity?.name,
            usuario: item?.user?.fullName,
            email: item?.user?.email,
            code: item?.code,
            start: format(
               parseISO(item.schedule.start),
               'EEEE dd LLL - HH:mm',
               { locale: es },
            ),
            end: format(parseISO(item.schedule.end), 'EEEE dd LLL - HH:mm', {
               locale: es,
            }),
            penalizado: item?.penalty ?? 0,
         })),
      );
      excel.createDefaultExcel();
   };

   const handleFiltrar = async () => {
      const res = await http(
         `/reservation/export?tower=${towerSeleted}&start=${fechaInicio}&end=${fechaFin}`,
         'GET',
      );
      if (res.data.data.list) {
         setFiltered(res.data.data.list);
      }
   };

   return (
      <div className="px-10 py-5 bg--100 h-full flex flex-col">
         <TowerList
            towers={tower}
            towerSelected={towerSeleted}
            onSelectTower={setTowerSelected}
         />

         <div className="flex justify-between items-center my-3">
            <ul className="flex flex-wrap text-sm font-medium text-gray-500">
               <Tab
                  label="Reservaciones"
                  isActive={view === typeView.RESERVACIONES}
                  onClick={() => setView(typeView.RESERVACIONES)}
               />
               <Tab
                  label="Servicios a reservaciones"
                  isActive={view === typeView.SERVICIOS}
                  onClick={() => setView(typeView.SERVICIOS)}
               />
            </ul>
            <button
               className="px-4 py-3 rounded-lg text-white bg-blue-600"
               onClick={() => {
                  setShowReporte(true);
               }}>
               VER REPORTE
            </button>
         </div>

         {view === typeView.RESERVACIONES && (
            <div className="overflow-y-auto min-h-[400px] max-h-[600px] grid grid-cols-4 gap-2 pb-10">
               {listReservations.map((reservation) => (
                  <ReservationCard
                     key={reservation._id}
                     reservation={reservation}
                     onPenalize={(reservationId, userId) => {
                        setStop(true);
                        setForm({ ...form, reservationId, userId });
                        setShowModalPenalizacion(true);
                     }}
                  />
               ))}
            </div>
         )}

         {view === typeView.SERVICIOS && (
            <div className="grid grid-cols-3 gap-2">
               {menus.map((item, index) => (
                  <ServiceCard
                     key={index}
                     item={item}
                     index={index}
                     setShowModal={setShowModal}
                     setItemsSelected={setItemsSelected}
                  />
               ))}
            </div>
         )}

         <Modal
            isOpen={showModal}
            title="Servicios"
            description="Agregue lo necesario para que la torre tenga la información correcta"
            onClose={() => {
               setItemsSelected([]);
               setShowModal(false);
            }}
            actions={
               <div className="createUser-actions-modal">
                  <Button
                     className="actions-item"
                     onClick={() => setShowModal(false)}>
                     Cancelar
                  </Button>
                  <Button
                     className="actions-item"
                     onClick={() => setShowModal(false)}>
                     Aceptar
                  </Button>
               </div>
            }
            width={1000}>
            <div className="grid grid-cols-2 w-full">
               {itemsSelected.map((item, index) => (
                  <ItemPrint key={index} item={item} />
               ))}
            </div>
         </Modal>
         <Modal
            actions={
               <div className="createUser-actions-modal">
                  <Button
                     className="actions-item"
                     onClick={() => {
                        setStop(false);
                        setShowModalPenalizacion(false);
                     }}
                     aria-label="Cancelar penalización">
                     Cancelar
                  </Button>
                  <Button
                     className="actions-item"
                     onClick={() => {
                        handlerSend();
                     }}
                     aria-label="Enviar penalización"
                     disabled={!form.penalty || isNaN(form.penalty)} // Deshabilitar si no hay un valor o es inválido
                  >
                     Penalizar
                  </Button>
               </div>
            }
            isOpen={showModalPenalizacion}
            title="Penalizar"
            description=""
            onClose={() => {
               setStop(false);
               setShowModalPenalizacion(false);
            }}
            width={500}
            height={300}
            aria-labelledby="penalization-modal-title"
            aria-describedby="penalization-modal-description">
            <div className="grid grid-cols-2 w-full h-full justify-center items-center">
               <input
                  id="penalty-input"
                  placeholder="0"
                  name="penalty"
                  className="mt-2 flex h-10 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-300 dark:!border-white/10 dark:text-white"
                  type="text"
                  value={form.penalty || ''}
                  onChange={(event) => {
                     const value = event.target.value;
                     // Solo actualizar si el valor es un número o vacío
                     if (value === '' || !isNaN(value)) {
                        setForm({
                           ...form,
                           penalty: value,
                        });
                     }
                  }}
                  aria-labelledby="penalty-input"
               />
            </div>
         </Modal>

         <Modal
            isOpen={showReporte}
            title={`Reporte de reservaciones (estas filtando por torre)`}
            description={''}
            onClose={() => {
               setShowReporte(false);
               setFiltered([]);
            }}
            width={window.innerWidth - 300}
            height={window.innerHeight - 200}>
            <div className="flex items-center justify-center bg-black bg-opacity-50">
               <div
                  className="bg-white rounded-lg shadow-lg p-6 overflow-auto"
                  style={{
                     width: 'calc(100vw - 300px)',
                     height: 'calc(100vh - 400px)',
                  }}>
                  <h2 className="text-xl font-semibold mb-4">
                     Reporte de Reservaciones
                  </h2>

                  {/* Filtros */}
                  <div className="flex flex-wrap gap-4 mb-4 items-end">
                     <div>
                        <label className="block text-sm font-medium">
                           Fecha Inicio
                        </label>
                        <input
                           type="date"
                           value={fechaInicio}
                           onChange={(e) => setFechaInicio(e.target.value)}
                           className="border border-gray-300 rounded px-2 py-1"
                        />
                     </div>
                     <div>
                        <label className="block text-sm font-medium">
                           Fecha Fin
                        </label>
                        <input
                           type="date"
                           value={fechaFin}
                           onChange={(e) => setFechaFin(e.target.value)}
                           className="border border-gray-300 rounded px-2 py-1"
                        />
                     </div>
                     <button
                        onClick={handleFiltrar}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                        Filtrar
                     </button>
                     <button
                        onClick={handleDescargar}
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                        Descargar Excel
                     </button>
                  </div>

                  {/* Tabla */}
                  <div className="overflow-x-auto">
                     <table className="min-w-full border border-gray-300 text-sm">
                        <thead className="bg-gray-100">
                           <tr>
                              {[
                                 { headerName: 'TORRE', field: 'tower' },
                                 { headerName: 'PISO', field: 'piso' },
                                 { headerName: 'AMENIDAD', field: 'amenidad' },
                                 { headerName: 'USUARIO', field: 'usuario' },
                                 { headerName: 'CORREO', field: 'email' },
                                 { headerName: 'CLAVE', field: 'code' },
                                 { headerName: 'INICIO', field: 'start' },
                                 { headerName: 'FIN', field: 'end' },
                                 {
                                    headerName: 'PENALIZADO',
                                    field: 'penalizado',
                                 },
                              ].map((header) => (
                                 <th
                                    key={header.field}
                                    className="px-4 py-2 border text-left">
                                    {header.headerName}
                                 </th>
                              ))}
                           </tr>
                        </thead>
                        <tbody>
                           {filtered.length === 0 ? (
                              <tr>
                                 <td
                                    colSpan="3"
                                    className="text-center py-4 text-gray-500">
                                    No hay resultados
                                 </td>
                              </tr>
                           ) : (
                              filtered.map((item, idx) => (
                                 <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border">
                                       {item?.tower?.name}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {item?.floor?.name}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {item?.amenity?.name}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {item?.user?.fullName}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {item?.user?.email}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {item?.code}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {format(
                                          parseISO(item.schedule.start),
                                          'EEEE dd LLL - HH:mm',
                                          { locale: es },
                                       )}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {format(
                                          parseISO(item.schedule.end),
                                          'EEEE dd LLL - HH:mm',
                                          {
                                             locale: es,
                                          },
                                       )}
                                    </td>
                                    <td className="px-4 py-2 border">
                                       {item?.penalty ?? 0}
                                    </td>
                                 </tr>
                              ))
                           )}
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </Modal>
      </div>
   );
}
